import React from 'react';
import { getThemeColors } from '../../../../lib/theme';

export function ActionBtn({
  onClick, title, dark, danger, children,
}: {
  onClick: () => void;
  title: string;
  dark: boolean;
  danger?: boolean;
  children: React.ReactNode;
}) {
  const t = getThemeColors(dark);
  return (
    <button
      type="button"
      title={title}
      onClick={onClick}
      style={{
        width: 26, height: 26, borderRadius: 6,
        border: `1px solid ${danger ? '#fda29b' : t.border}`,
        background: danger ? (dark ? '#1a0505' : '#fff5f5') : 'transparent',
        color: danger ? '#b42318' : t.muted,
        fontSize: 12, cursor: 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        transition: 'opacity 0.1s',
      }}
    >{children}</button>
  );
}
